module.exports = __webpack_public_path__ + "img/trash_icon.317c88b2.svg";